import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import {
  AddressFragment,
  CustomerAddressFragment
} from '@/helpers/api/fragments'

const output = `
  ...CustomerAddress
  address {
    ...Address
  }
`
const fragments = gql`
  ${CustomerAddressFragment}
  ${AddressFragment}
`

const allowedFields = [
  'customer_id',
  'address_id',
  'alias',
  'is_active',
  'updated_at',
  'created_at'
]

export default config => {
  const service = createService({
    ...config,
    table: 'customer_address',
    defaultSearchBy: [
      'alias',
      { address: ['attn', 'city', 'company_name', 'country_code'] }
    ],
    primaryKey: ['customer_id', 'address_id'],
    defaultOrderBy: [{ alias: 'asc' }],
    defaultFilters: [{ is_active: { _eq: true } }],
    defaultOutput: output,
    defaultFragments: fragments,
    allowedFields
  })

  return {
    ...service
  }
}
